import React, { useState } from 'react';
import { prop } from 'ramda';
import Form from 'js/components/common/Form';
import { useTranslations } from 'js/hooks/i18n';
import { Button } from 'js/components/common/Button';
import { useUserSelector } from 'js/store/hooks';
import { Select } from 'js/components/common/Fields/Select';
import { componentService } from 'js/services/component.service';
import { DatePicker } from 'js/components/common/Fields/DatePicker';

import { useValidate } from './hooks';
import { Radio } from 'js/components/common/Fields/Radio';
import { TAX_FORM_TYPES, W_2G_TAX_FORMS } from './constants';

import style from './TaxStatementsForm.scss';

export const TaxStatementsForm = () => {
    const currentDate = new Date();
    const [result, setResult] = useState(false);
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const t = useTranslations('playtech.mobile.system.taxStatements.');
    const validate = useValidate(t('date.error'));
    const initialValues = {
        to: currentDate,
        formType: TAX_FORM_TYPES.W_2G,
        w2gType: W_2G_TAX_FORMS.CASINO,
        from: new Date(currentDate.getFullYear() - 1, 0, 1)
    };
    const formatDate = date => typeof date === 'number' ? new Date(date) : date;

    const onSubmit = ({ formType, w2gType, from, to }) => {
        const formData = {
            formType,
            w2gType,
            to: formatDate(to),
            from: formatDate(from)
        };

        setResult(true);

        console.log('Tax Statements Form: ', formData);
    };

    if (!isLoggedIn) {
        return <p>{t('notLoggedIn')}</p>;
    }

    return (
        <Form
            onSubmit={onSubmit}
            validate={validate}
            initialValues={initialValues}
            render={({ handleSubmit, values: { formType } }) => (
                <form className={style.container} onSubmit={event => event.preventDefault()}>
                    <h3 className={style.alignCenter}>{t('title')}</h3>
                    <Select
                        name="formType"
                        className={style.control}
                        label={t('formType.label')}
                        options={[{
                            label: t('formType.w2g'),
                            value: TAX_FORM_TYPES.W_2G
                        }, {
                            label: t('formType.netWinLoss'),
                            value: TAX_FORM_TYPES.NET_WIN_LOSS
                        }]}
                    />
                    {formType === TAX_FORM_TYPES.W_2G && (
                        <div className={style.radios}>
                            <Radio
                                type="radio"
                                name="w2gType"
                                label={t('w2gType.casino')}
                                value={W_2G_TAX_FORMS.CASINO}
                            />
                            <Radio
                                type="radio"
                                name="w2gType"
                                label={t('w2gType.sportsbook')}
                                value={W_2G_TAX_FORMS.SPORTSBOOK}
                            />
                        </div>
                    )}
                    <DatePicker
                        name="from"
                        label={t('filter.from')}
                        isPickersSeparate={true}
                        className={`${style.control} ${style.datePickerControl}`}
                    />
                    <DatePicker
                        name="to"
                        label={t('filter.to')}
                        isPickersSeparate={true}
                        className={`${style.control} ${style.datePickerControl}`}
                    />
                    <div className={style.alignCenter}>
                        <Button
                            type="button"
                            onClick={handleSubmit}
                        >
                            {t('button.filter')}
                        </Button>
                    </div>
                    {result && <p className={style.alignCenter}>{t('filter.result')}</p>}
                </form>
            )}
        />
    );
};

componentService.registerWebContentComponents({ TaxStatementsForm });
